import React from "react";
import { renderGoogleButton } from "../../utils/googleSignIn.js";

/** Shared slot classes — keep outline borders visible on desktop + mobile. */
export const GOOGLE_BUTTON_SLOT_CLASS =
  "google-continue-slot box-border w-full max-w-full overflow-visible py-0.5 flex justify-center items-center min-h-[44px]";

/**
 * Official Google "Continue with Google" button slot.
 * Re-initializes when `remountKey` changes (e.g. signup wizard step).
 */
export default function GoogleContinueButton({
  onCredential,
  onError,
  disabled = false,
  remountKey = "default",
  className = "",
}) {
  const slotRef = React.useRef(null);
  const onCredentialRef = React.useRef(onCredential);
  const onErrorRef = React.useRef(onError);

  onCredentialRef.current = onCredential;
  onErrorRef.current = onError;

  React.useEffect(() => {
    const el = slotRef.current;
    if (!el) return undefined;
    let cancelled = false;
    let cleanup = null;

    void renderGoogleButton(
      el,
      (credential) => {
        if (!cancelled) return onCredentialRef.current?.(credential);
      },
      (message) => {
        if (!cancelled) onErrorRef.current?.(message);
      }
    ).then((fn) => {
      if (cancelled) {
        fn?.();
        return;
      }
      cleanup = fn;
    });

    return () => {
      cancelled = true;
      cleanup?.();
      try {
        el.innerHTML = "";
      } catch {
        /* ignore */
      }
    };
  }, [remountKey]);

  return (
    <div
      ref={slotRef}
      className={`${GOOGLE_BUTTON_SLOT_CLASS} ${
        disabled ? "pointer-events-none opacity-60" : ""
      } ${className}`}
    />
  );
}
